import { useEffect } from "@wordpress/element";
import WidgetContextProvider from "../context/widget-context-provider";
import LicenseContextProvider from "../context/license-context-provider";
import App from "./widget/app";
import OffcanvasAssistant from "./widget/scan/scan-app";
import { Toaster } from "../components/ui/sonner";
import { AnimationProvider } from "@/context/animation-provider";
import ScanContextProvider from "@/context/scan-context-provider";

const WidgetApp = () => {
	return (
		<LicenseContextProvider>
			<WidgetContextProvider>
				<ScanContextProvider>
					<AnimationProvider>
						<Toaster richColors position="top-left" />
						<App />
						<OffcanvasAssistant />
					</AnimationProvider>
				</ScanContextProvider>
			</WidgetContextProvider>
		</LicenseContextProvider>
	);
};

export default WidgetApp;
